<template>
  <div class="company-contain">
    <div v-show="loading" class="page-loading" style="width:100%;height:100%;position:fixed;top:0;;background:#000000;z-index:10000;opacity:0.8; max-width: 640px;">
      <div class="loading-box" style="box-sizing: content-box !important;position: absolute;z-index: 10001;margin: 0px; padding: 0px;top: 50%;left: 50%;text-align: center;transform: translate(-50%, -50%);">
        <div class="loading-img"></div>
      </div>
    </div>

    <div class="search-company-box">      
      <div class="pledge-box1">   
        <div class="pledge-box1-top"> 
          <div class="Quarterly-Report" style="float: left;" v-if="allDateTyp.length > 0">
            <div class="head-title"  @click.stop="showDateDropmemu($event)">
              <template v-if="curDateTyp == 'ALL'">全部</template>
              <template v-if="curDateTyp != 'ALL'">{{ curDateTyp }}</template>
              <span class="close-bot"  @click.stop="showDateDropmemu($event)"></span>
            </div>
            <ul class="menu-lanmu" v-show="dateDropmenu">  
              <!-- <li>
                <a href="javascript:;" v-if="curDateTyp != 'ALL'" @click="clickDropmenu(), curDateTyp = 'ALL', filter()">全部</a>
              </li> -->
              <li v-for="h in allDateTyp">
                <a href="javascript:;" v-if="curDateTyp != h" @click="clickDropmenu(), curDateTyp = h, filter()">{{ h }}</a>
              </li>
            </ul>
          </div>
        </div> 

        <div class="pledge-box1" v-if="industryList.length > 0"> 
          <template v-if="showYysr">
            <div class="pledge-box1-top">
              <h3>营业收入(元)</h3> 
            </div>
            <div class="Single-list-main">  
              <ul class="Single-list-box">
                <template v-for="h in industryList" track-by="$index">
                  <li v-if="h.yysr">
                    <p class="date">{{ h.name }}</p> 
                    <p class="time">{{ h.yysr | money }}</p>
                  </li>
                </template>
              </ul>   
            </div> 
          </template>

          <template v-if="showYycb">
            <div class="pledge-box1-top">
              <h3>营业成本(元)</h3> 
            </div>
            <div class="Single-list-main">  
              <ul class="Single-list-box">
                <template v-for="h in industryList" track-by="$index">
                  <li v-if="h.yycb">
                    <p class="date">{{ h.name }}</p> 
                    <p class="time">{{ h.yycb | money }}</p>
                  </li>
                </template>
              </ul>   
            </div> 
          </template>  

          <template v-if="showYylr">
            <div class="pledge-box1-top">
              <h3>营业利润(元)</h3> 
            </div>
            <div class="Single-list-main">  
              <ul class="Single-list-box">
                <template v-for="h in industryList" track-by="$index">
                  <li v-if="h.yylr">
                    <p class="date">{{ h.name }}</p> 
                    <p class="time">{{ h.yylr | money }}</p>
                  </li>
                </template>
              </ul>   
            </div>
          </template> 
        </div> 
      </div>
    </div>
  </div>

  <!--微信绑定弹框-->
  <div aria-hidden="false" aria-labelledby="myModalLabel" role="dialog" tabindex="-1" id="dialog" class="modal fade in" v-show="tipGoBind">
    <div class="binding-content">
      <a class="binding-logo"></a>
      <div class="binding-text">
        立即绑定IBDATA账号<br/>成为金融分析高手
      </div>
      <div class="binding-bot">
        <a class="binding-no-btn" @click="tipGoBind = false">暂不绑定</a>
        <a class="binding-btn" @click="goBindPage">立即绑定</a>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade in" v-show="tipGoBind"></div>
  <!-- / 微信绑定弹框-->
</template>

<script>
  import { alert, apiUrl, downloadURL } from '../../helper'
  import $ from 'jquery'
  import userMix from '../../common/userMix'
  import searchMix from '../../common/searchMix'
  import comSearchMix from '../../common/comSearchMix'
  import companyMix from '../../common/companyMix'
  import wxshareMix from '../../common/wxshareMix'

  export default {
    name: 'InvestView',
    mixins: [userMix, searchMix, comSearchMix, companyMix, wxshareMix],
    data () {
      return {
        originData: [],
        industryList: [],
        page: 1,
        perPage: 10,
        total: 0,
        totalPage: 0,
        beutifulData: '',   // 渲染表格所需数据结构
        beutifulDate: [],   // 渲染表格所需日期
        allDateTyp: [],
        curDateTyp: 'ALL',
        yysr_rows: 0,
        yycb_rows: 0,
        yylr_rows: 0,
        showYysr: false,
        showYycb: false,
        showYylr: false,
      }
    },
    route: {
      data({to}) {

        if (!this.currentuser) {
          this.wxcode = this.getQueryString('code')  // 获取微信登录code
          if (this.wxcode) {
            this.wxlogin(this.wxcode)
          } else {
            this.getProfile(to.query.share)
          }
        }

        if (this.currentuser) {
          this.queryParam = to.query;
          this.companycode = to.query.companycode;
          this.stype = to.query.stype;

          // 微信签名 分享
          let title = decodeURIComponent(to.query.desc);
          let desc = '你的朋友' + this.currentuser.username + '通过IBDATA给你分享了一份他的独家数据！';
          document.title = title;
          this.getwxsign()    // 微信签名
          this.shareCompany(title, desc);

          this.setSelectedTab();
          this.getIndustry();
        }
      }
    },
    filters: {
      nullValue: function(param) {
        if (!param || param == '') {
          return '-'
        } else {
          return param;
        }
      },
    },
    watch: {
      'industryList': function(curVal, oldVal) {
        this.showYysr = false;
        this.showYycb = false;
        this.showYylr = false;

        for (let h of this.industryList) {
          if (h.yysr) { this.showYysr = true; }
          if (h.yycb) { this.showYycb = true; }
          if (h.yylr) { this.showYylr = true; }
        }
      }
    },
    methods: {
      // 行业
      getIndustry: function() {

        this.loading = true;
        
        let query = {};
        query.companycode = this.companycode;
        query.uid = parseInt(this.queryParam.uid)
        query.ruid = parseInt(this.queryParam.ruid)
        query.share = this.queryParam.share
        query.plat = this.queryParam.plat
        query.sid = this.queryParam.sid

        $.ajax({
          url: apiUrl('/V1.0.0/company/mainindustrylist'),
          method: 'post',
          dataType: 'json',
          // data: JSON.stringify({'companycode': this.companycode})
          data: JSON.stringify(query)
        }).done((response) => {

          this.loading = false;
          if (response.status === 0) {
            this.industryList = response.data;
            this.originData = response.data;
            this.total = response.data.length;
            this.totalPage = Math.ceil(this.total / this.perPage);

            this.industryList.sort((a, b) => {
              return Date.parse(b.updtime) - Date.parse(a.updtime);
            });

            let tmp = {};
            for (let h of this.industryList) {
              if (!tmp[h.reportdatestr]) {
                tmp[h.reportdatestr] = true;
                this.allDateTyp.push(h.reportdatestr);
              }
            }

            this.curDateTyp = this.allDateTyp[0];
            this.filter();
          } else {
            alert(response.description)
          }

        }).fail((response) => {

          this.loading = false;
          alert('请求失败')

        })
      },
      filter: function() {

        this.loading = true;

        let arr = [];
        let date = this.curDateTyp;

        for (let h of this.originData) {
          if (h.reportdatestr === date) {
            arr.push( h );
          }
        }

        this.industryList = arr;

        let that = this;
        setTimeout(() => {
          that.loading = false;
        }, 500)
      },
      showDateDropmemu: function() {
        this.dateDropmenu = this.dateDropmenu ? false : true;
      },
      clickDropmenu: function() {
        this.dateDropmenu = false;
      },
    }
  }
</script>

<style scoped>
  /* 加载 */
  .loading-box {
    top: 43% !important;
  }
  .loading-img {
    width: 35px;
    height: 35px;
    background-image: url('../../../static/images/loading2.gif');
    background-size: cover;
  }

  .Quarterly-Report .head-title {
    display: block;
  }
</style>


/** WEBPACK FOOTER **
 ** Industry.vue?4c196f26
 **/